const MODULE_NAME = 'UsersModule';

export const USERS_USER_CHANGE_PASSWORD = `${MODULE_NAME}/USER_CHANGE_PASSWORD`;
export const USERS_SET_USER_PASSWORD = `${MODULE_NAME}/SET_USER_PASSWORD`;
export const USERS_CREATE_OKTA_USER = `${MODULE_NAME}/CREATE_OKTA_USER`;
export const USERS_FORGOT_PASSWORD = `${MODULE_NAME}/FORGOT_PASSWORD`;
export const USERS_UPDATE_QUESTION = `${MODULE_NAME}/UPDATE_QUESTION`;
export const USERS_GET_SECURITY_QUESTIONS = `${MODULE_NAME}/GET_SECURITY_QUESTIONS`;
export const USERS_GET_CURRENT = `${MODULE_NAME}/USERS_GET_CURRENT`;
export const USERS_GET_USERS = `${MODULE_NAME}/GET_USERS`;
export const USERS_GET_USERS_PENDING_APPROVAL = `${MODULE_NAME}/GET_USERS_PENDING_APPROVAL`;
export const USERS_GET_USERS_LOGGED_IN_TODAY = `${MODULE_NAME}/GET_USERS_LOGGED_IN_TODAY`;
export const USERS_GET_USERS_REJECTED = `${MODULE_NAME}/GET_USERS_REJECTED`;
export const USERS_GET_USERS_WITHOUT_SEPIA_INFO = `${MODULE_NAME}/GET_USERS_WITHOUT_SEPIA_INFO`;
